import "./style.scss";

import { InputLabel } from "@mui/material";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { useEffect } from "react";
import type { SubmitHandler } from "react-hook-form";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
// Imports from React
import { useDispatch, useSelector } from "react-redux";
import { fetchCreateEntry, fetchEntries } from "store/accountingStore";
// Imports from store
import type { AppDispatch, RootState } from "store/store";

export const textFieldStyles = {
    "&.MuiTextField-root": {
        margin: "auto",
        width: "350px",
    },
    ".MuiFormHelperText-root": {
        color: "rgb(211, 47, 47)",
    },
};

export type TFormEntry = {
    name: string;
};

interface CreateTypology {
    close: (success: boolean) => void;
    onCreate: (name: string) => void;
}

const CreateTypology = ({ close, onCreate }: CreateTypology) => {
    const [t] = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const { entries } = useSelector((state: RootState) => state.accounting);

    const onSubmit: SubmitHandler<TFormEntry> = (form) => {
        const entryExists = entries.find((entry) => entry.name == form.name);
        const defaultEntry = entries.find((entry) => entry.name == "Par défaut");
        if (!entryExists && defaultEntry) {
            dispatch(
                fetchCreateEntry({
                    ...defaultEntry,
                    name: form.name,
                    filters: {
                        ...defaultEntry.filters,
                        typology: form.name,
                    },
                }),
            ).then((resp) => {
                if (resp.meta.requestStatus === "fulfilled") {
                    const newTypologyId = (resp.payload as any).data.id;
                    onCreate(form.name);
                    close(true);
                }
            });
        }
    };

    useEffect(() => {
        dispatch(fetchEntries());
    }, []);

    const methods = useForm<TFormEntry>({
        defaultValues: {
            name: "",
        },
    });
    const { control, handleSubmit } = methods;

    return (
        <div className="typology-modal-wrapper">
            <h3>{t("Accounting.AddEntryText")}</h3>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <div className="input-group-form" style={{ marginBottom: "1rem" }}>
                            <InputLabel
                                sx={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    fontFamily: "Poppins",
                                    marginLeft: "0.3rem",
                                    color: "rgb(131 130 130)",
                                }}
                                htmlFor="name"
                            >
                                {t("Accounting.EntryTypeName")}
                            </InputLabel>
                            <StyledTextField id="name" sx={textFieldStyles} {...field} />
                        </div>
                    )}
                />
                <div className="duplicate-modal-btn">
                    <button className="btn-cancel" onClick={() => close(true)}>
                        {t("Accounting.Cancel")}
                    </button>
                    <button className="btn-validate" type="submit">
                        {t("NewBeneficiary.Create")}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreateTypology;
